import script from "./AdminPortal.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPortal.vue?vue&type=script&setup=true&lang=js"

import "./AdminPortal.vue?vue&type=style&index=0&id=388ae592&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-388ae592"]])

export default __exports__